// baby: Re-export shared 8-bit theme toggle
export { Ninxl8BitThemeToggle } from '@/app/(marketing)/_components/8bit'
